module.exports = __webpack_public_path__ + "img/fig04.79b4fa83.jpg";